module.exports = __webpack_public_path__ + "img/banner6.6ffadc01.png";